import React from "react";
import Chart from "react-apexcharts";

interface EpsSparklineProps {
  epsGrowthData: {
    series: { name: string; data: string[] }[];
    categories: string[];
  } | null;
}

export const EpsChartline: React.FC<EpsSparklineProps> = ({
  epsGrowthData,
}) => {
  if (!epsGrowthData?.series?.[0]?.data?.length) {
    return <span className="text-gray-300 text-xs">-</span>;
  }

  const numericData = epsGrowthData.series[0].data.map((v) =>
    parseFloat(v.replace("%", "")),
  );

  const allNegative = numericData.every((v) => v <= 0);
  const lineColor = allNegative ? "#dc2626" : "#16a34a";

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "area",
      sparkline: { enabled: false },
      animations: { enabled: false },
      toolbar: { show: false },
      zoom: { enabled: false },
      offsetX: 0,
      offsetY: 0,
      fontFamily: "inherit",
      fontSize: "8px",
    } as any,
    grid: {
      borderColor: "var(--vi-card-border)",
      strokeDashArray: 4,
      padding: {
        top: 5,
        right: 15,
        bottom: 0,
        left: 0,
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 100],
      },
    },
    colors: [lineColor],
    dataLabels: {
      enabled: true,
      formatter: (val: any) => `${Number(val).toFixed(1)}%`,
      style: {
        fontSize: "8px",
        fontWeight: 500,
        colors: [lineColor],
      },
      background: { enabled: false },
      offsetY: -6,
    },
    tooltip: {
      enabled: true,
      style: { fontSize: "8px" },
      y: {
        formatter: (val: any) => `${Number(val).toFixed(1)}%`,
      },
      x: {
        formatter: (_: any, opts: any) =>
          epsGrowthData.categories[opts.dataPointIndex]?.replace(/\s+/g, " ") ??
          "",
      },
    },
    yaxis: {
      min: Math.min(...numericData) - 10,
      max: Math.max(...numericData) + 20,
      labels: {
        formatter: (val: any) => `${Number(val).toFixed(0)}%`,
        style: { fontSize: "8px" },
        offsetX: -15,
      },
    },
    xaxis: {
      categories: epsGrowthData.categories.map((c) =>
        c.replace(/\s+/g, " ").trim(),
      ),
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <div
      style={{
        margin: "-30px -4px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Chart
        type="area"
        series={[{ name: "EPS Growth", data: numericData }]}
        options={options}
        width={150}
        height={120}
      />
    </div>
  );
};
